import React from 'react';
const StaticPage = React.lazy(() => import('components/StaticPage'));

const Policy = () => <StaticPage category="policy" name="terms" />;

export default Policy;
